import { RECAPTCHA_V3_KEY } from "common/variables";

export const executeRecaptcha = (opts) => {
  if (window?.grecaptcha?.execute) {
    return window.grecaptcha.execute(RECAPTCHA_V3_KEY, opts);
  }
  return Promise.resolve();
};
